import React from "react";
import PropTypes from "prop-types";
import {
  NavLink,
  Navigate,
  Outlet,
  useRoutes,
  useLocation,
 } from "react-router-dom";
import useTabs from "../../hooks/useTabs";

import "./VerticalRoutedTabs.scss";

function VerticalRoutedTabs({
  tabs,
  tabIdAccessor,
  targetPanelIdAccessor,
  defaultTabId,
  titleRenderer = (tab) => tab.title,
  contentRenderer = (tab) => tab.content,
}) {

  const {
    tabs:tablist,
    getContainerProps,
    getTabProps,
    getPanelProps,
  } = useTabs({
    tabs, tabIdAccessor, targetPanelIdAccessor, defaultTabId
  })

  const defaultTab = tablist.find((tab) => tab[tabIdAccessor] === defaultTabId)
  const location = useLocation();
  const { state } = location;

  const tabRoutes = []
  console.debug('state?.backgroundLocation', state?.backgroundLocation)
  if (state?.backgroundLocation)
    tabRoutes.push({ index: true, element: <Navigate to={{path: `/${defaultTab.pathName}`, state}} replace/> })
  else
    tabRoutes.push({ index: true, element: <Navigate to={defaultTab.pathName} replace/> })

  tablist.forEach(tab => {
    tabRoutes.push({
      path: tab.pathName,
      element: <div className="tab-pane d-block" {...getPanelProps(tab[tabIdAccessor])}>{ contentRenderer(tab) }</div>
    })
  });

  console.log({tabRoutes});

  let routes= [
    {
      path: "/",
      element: <Layout 
        tablist={tablist}
        getContainerProps={getContainerProps}
        getTabProps={getTabProps}
        tabIdAccessor={tabIdAccessor}
        titleRenderer={titleRenderer}
      />,
      children: tabRoutes
    }
  ];

  let element = useRoutes(routes);
  console.debug("_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_ VerticalTabs::Main -_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_")
  return element
}

function Layout({tablist, getContainerProps, getTabProps, tabIdAccessor, titleRenderer}) {
  const location = useLocation();
  const { state } = location;
  console.debug("_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_ VerticalTabs::Layout -_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_")
  return (
    <div className="vertical-tabs-container" {...getContainerProps}>
      <div className="px-md-3 px-0 navigation-tabs-container">
        <ul className="nav flex-md-column nav-tabs" id="nav-tab">
          {
            tablist.map(tab => (
              <li className="nav-item" key={tab[tabIdAccessor]} {...getTabProps(tab[tabIdAccessor])}>
                <NavLink to={tab.pathName} state={state} className={`nav-link ${tab.decoratorClass}`}>
                  <span style={{color: 'black'}}>{ titleRenderer(tab) }</span>
                </NavLink>
              </li>
            ))
          }
        </ul>
      </div>
      <div className="px-md-3 px-0 tab-content-container">
        <div className="tab-content" id="v-pills-tabContent">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

VerticalRoutedTabs.defaultProps = {};

VerticalRoutedTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  tabIdAccessor: PropTypes.string.isRequired,
  targetPanelIdAccessor: PropTypes.string.isRequired,
  defaultTabId: PropTypes.string.isRequired,
  titleRenderer: PropTypes.func,
  contentRenderer: PropTypes.func,
};

export default VerticalRoutedTabs;